import { useLocation, useHistory } from 'react-router-dom';

const useParamsQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const deleteQuery = () => {
  const history = useHistory();

  const queryParams = new URLSearchParams(useLocation().search);

  queryParams.delete('subscriptionId');
  queryParams.delete('token');

  history.replace({
    subscriptionId: queryParams,
    token: queryParams,
  });
};

const selectSubscription = (subscriptionId, token) => {
  const history = useHistory();
  history.push({
    subscriptionId,
    token,
  });
};

export { useParamsQuery, deleteQuery, selectSubscription };
